









































































































































































import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";
import * as _ from 'lodash';
import { DxButton } from "devextreme-vue/ui/button";
import DSelectbox from "@/components/DSelectbox/selectbox.vue";
import { DxPopup } from "devextreme-vue";
import DTextbox from "@/components/DTextbox/textbox.vue";
import DTagbox from "@/components/DTagbox/tagbox.vue";
import DxScrollView from 'devextreme-vue/scroll-view';
import { DxCheckBox } from "devextreme-vue/check-box";
import { CutType, CutWithAccept, EcoObjectType, EcoVersionType, YearType } from "@/services/models-service";
import {type_cut, months, periods} from "@/constants";
import CutService, { IAcceptedMonth } from "@/services/cut-service";
import { confirm } from "devextreme/ui/dialog";
import EcoVersionService  from "@/services/eco-versions-service";
import EcoObjectsService  from "@/services/eco-objects-service";
import AnimatePopup from '@/components/AnimatePopup/animate-popup.vue';
import {alert} from 'devextreme/ui/dialog';
import WebSocketService from "@/services/websocket_service";
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import notify_service from "@/services/notify_service";


@Component({
  name: "CutPopup",
  components: {
    DxButton,
    DSelectbox,
    DxPopup,
    DTextbox,
    DxCheckBox,
    DTagbox,
    DxScrollView,
    AnimatePopup,
    DxLoadPanel
  }
})
export default class extends Vue {
@PropSync('popupOptions') public localPopupOptions: any;
@Prop() public all_years: YearType[];
@Prop() public current_year: string;
@Prop() public target_cut: CutWithAccept;
@Prop() public cuts: any[];
public localTypeCut = type_cut;
public allFilial: any [] = [];
public allFacility: any [] = [];
public ecoVersions: EcoVersionType [] | null = null;
public cut: CutWithAccept = new CutWithAccept();
public allTypeCuts: CutType [] = [];
public cutsBusiness: CutType [] = [];
public cutsFacts: CutType [] = [];
public cutsUsers: CutType [] = [];
public current_cuts: CutType [] = [];
public isSave:boolean = false;
public analyze_cut:boolean = false;
public copyPermissions: any = {
    tariffs: false,
    contractor: false,
    purchases: false,
    sales: false,
    transport_expenses: false,
    transport_revenue: false,
    objects: false,
    okhn: false,
    fb2_use_leave: false,
    fb2_tec_loses: false,
    fb2_com_loses: false
};
// Список ранее акцептированных месяце для данной срезки
private acceptedMonthList: string[] = [];

@Watch('cut.visible_for')
changeVisible(){
    console.log(this.cut.visible_for)
}

public valid_cut = {
    name: true,
    type: true,
    filial: true,
    object: true,
    eco: true,
    visible_for: true
}

public visibleForOptions = [
  { value: 'Видимый для администратора', label: 'Видимый для администратора' },
  { value: 'Видимый для всех', label: 'Видимый для всех' },
  { value: 'Скрыт для всех', label: 'Скрыт для всех' },
];

public get copyAnimatePopupOptions() {
    return {
      visible: this.isSave,
      text: 'Идёт работа с данными срезки...'
    }
}

public get monthsDS() {
  return months.map( (m):IAcceptedMonth => {
    return { ...m, isAccepted: this.acceptedMonthList.includes(m.code) };
  })
}

async created() {
    // @ts-ignore
    this.$options.sockets.onmessage = async (data: any) => {
        let res = WebSocketService.handleMsg(data, 'copy_cut');
       if (!_.isNil(res)){;
       
       

          if (!res.success && res.message) {
            notify_service.error(res.message)
          }

          this.isSave = false;
          this.$emit("getNewCuts");
          this.onClose();

       }
    }
    const resp = await EcoVersionService.get();
    if (resp.data) {
        this.ecoVersions = resp.data;
    }
}

  async mounted() {

  }

async onShowing() {
    this.cut.id_year = this.current_year;
    this.acceptedMonthList = [];
    if(this.target_cut && this.localPopupOptions.editMode) {
        this.cut = _.cloneDeep(this.target_cut);
        // ВЫбрать коды месяцев, для которых флаг акцепта был заранее указан
        periods.forEach(monthCode => {
          if (this.cut[monthCode as keyof CutWithAccept]) {
            this.acceptedMonthList.push(monthCode);
          }
        }, [])
        if(this.cut.copy_facility_name) {
            this.cut.copy_facility_name = JSON.parse(this.cut.copy_facility_name);
        }
        if(this.cut.copy_filial_name) {
            this.cut.copy_filial_name = JSON.parse(this.cut.copy_filial_name);
        }
    }
    const response = await CutService.getWithFilter(this.current_year);
        if (response.data) {
            this.current_cuts = response.data
        }
}

onShow() {
    if(this.localPopupOptions.editMode) {
      this.cut.copy_name = this.target_cut.copy_name;
    }
}

validation() {
    this.cut.name === "" ? this.valid_cut.name = false : this.valid_cut.name = true;
    if (this.valid_cut.name === true) {
        if(this.localPopupOptions.editMode) {
            const notUnique = this.current_cuts.find((c:CutType) => c.name === this.cut.name && c.id !== this.cut.id);
            notUnique ? this.valid_cut.name = false : this.valid_cut.name = true;
        } else {
            const notUnique = this.current_cuts.find((c:CutType) => c.name === this.cut.name);
            notUnique ? this.valid_cut.name = false : this.valid_cut.name = true;
        }
    }
    this.cut.id_eco_version === null ? this.valid_cut.eco = false : this.valid_cut.eco = true;
    this.cut.type === "" ? this.valid_cut.type = false : this.valid_cut.type = true;
    !this.cut.visible_for ? this.valid_cut.visible_for = false : this.valid_cut.visible_for = true;
    this.cut.copy_filial && (this.cut.copy_filial_name === null || (this.cut.copy_filial_name && this.cut.copy_filial_name.length === 0)) ? this.valid_cut.filial = false : this.valid_cut.filial = true;
    this.cut.copy_facility && (this.cut.copy_facility_name === null || (this.cut.copy_facility_name && this.cut.copy_facility_name.length === 0)) ? this.valid_cut.object = false : this.valid_cut.object = true;
}

async confirmSave() {
    // Проверка: если редактирование и strong_tariff_calc был выключен, а стал включён
    if (this.localPopupOptions.editMode && !this.target_cut.strong_tariff_calc && this.cut.strong_tariff_calc) {
        const answer = await confirm('При включении режима расчёта по тарифу будет произведён перерасчёт всех значений стоимости. Ручные корректировки будут удалены. Продолжить?', 'Внимание');
        if (!answer) {
            return;
        }
        // Обнуляем корректировки и пересчитываем стоимость по тарифу для всех объектов и филиалов
        await this.resetManualCorrectionsAndRecalc();
    }
    if(this.localPopupOptions.editMode) {
        await confirm(`Сохранить изменения "${this.cut.name}"?`, "Сохранение изменений").then(
            async (answer: boolean) => {
                if (!answer) {
                    return;
                } else {
                    await this.onCreate();
                }
            }
        )
    } else {
        await this.onCreate();
    }
}


async onCreate() {
    this.validation();
    if (!this.valid_cut.name || !this.valid_cut.eco || !this.valid_cut.type || !this.valid_cut.filial || !this.valid_cut.object || !this.valid_cut.visible_for) {
        return;
    }
    if ((!this.cut.copy_tariffs_value || !this.cut.copy_contractor) && (this.cut.copy_shop_value ||
        this.cut.copy_realization_value || this.cut.copy_transport_expenses_value || this.cut.copy_transport_revenue_value) && !this.localPopupOptions.editMode) {
        alert('Покупка, реализация, транспорт не будут скопированы без копирования тарифов и контрагентов. Отметьте указанные пункты для копирования.', 'Ошибка');
        return;
    }
    if (this.localPopupOptions.editMode && this.cut.copy_data && (!this.cut.copy_name || (!this.cut.copy_all_filials && !this.cut.copy_filial_name))) {
        alert('Заполните данные для копирования.', 'Ошибка');
        return;
    }
    if (!this.localPopupOptions.editMode && this.cut.copy_data && !this.cut.copy_name) {
        alert('Заполните данные для копирования.', 'Ошибка');
        return;
    }
    if (this.cut.copy_shop_value && !this.cut.copy_realization_value) {
        alert('При копировании/очистке Покупки необходимо выбрать Реализацию для синхронизации блоков ВНО/ВГО', 'Ошибка');
        return;
    }
    if (!this.cut.copy_shop_value && this.cut.copy_realization_value) {
        alert('При копировании/очистке Реализации необходимо и выбрать Покупку для синхронизации блоков ВНО/ВГО', 'Ошибка');
        return;
    }
    if (this.cut.copy_transport_expenses_value && !this.cut.copy_transport_revenue_value) {
        alert('При копировании/очистке Транспорт. Затраты необходимо и выбрать Транспорт. Выручка для синхронизации блоков ВГО', 'Ошибка');
        return;
    }
    if (!this.cut.copy_transport_expenses_value && this.cut.copy_transport_revenue_value) {
        alert('При копировании/очистке Транспорт. Выручка необходимо и выбрать Транспорт. Затраты для синхронизации блоков ВГО', 'Ошибка');
        return;
    }
    if (this.cut.copy_data && !this.cut.copy_tariffs_value && !this.cut.copy_contractor && !this.cut.copy_shop_value && !this.cut.copy_realization_value && !this.cut.copy_transport_expenses_value &&
        !this.cut.copy_transport_revenue_value && !this.cut.copy_ok_xn_loss_value && !this.cut.copy_objects && !this.cut.copy_grouped_objects) {
        alert('Выберите пункты для копирования.', 'Ошибка');
        return;
    }
    if (this.cut.clear_cut || this.cut.copy_data || this.cut.acceptance) this.isSave = true;
    if(!this.localPopupOptions.editMode) this.cut.number = this.cuts.length + 1;
    const cloneCut: any = _.cloneDeep(this.cut);
    if (cloneCut?.copy_facility_name) cloneCut.copy_facility_name = JSON.stringify(cloneCut.copy_facility_name);
    if (cloneCut?.copy_filial_name) cloneCut.copy_filial_name = JSON.stringify(cloneCut.copy_filial_name);
    if (cloneCut?.copy_id_year && cloneCut?.copy_name) {
        const year = this.all_years.find((y:YearType) => y.id === cloneCut?.copy_id_year);
        let cut;
        if (cloneCut.copy_type === this.localTypeCut[0].name) {
            cut = this.cutsBusiness.find((c:CutType) => c.id === cloneCut?.copy_name);
        }
        else if (cloneCut.copy_type === this.localTypeCut[1].name) {
            cut = this.cutsFacts.find((c:CutType) => c.id === cloneCut?.copy_name);
        }
        else if (cloneCut.copy_type === this.localTypeCut[2].name) {
            cut = this.cutsUsers.find((c:CutType) => c.id === cloneCut?.copy_name);
        }
        if (year && cut) {
            cloneCut.copy_year_name = year.name + " - " + cut.name;
        }
    }
    console.log(cloneCut)
    await CutService.save(cloneCut);
    this.$emit('refreshTable')
}

onClose() {
    this.cut = new CutWithAccept();
    this.valid_cut = {
        name: true,
        type: true,
        filial: true,
        object: true,
        eco: true,
        visible_for: true
    }
    this.localPopupOptions.editMode = false;
    this.localPopupOptions.visible = false;
}

destroyed() {
    // @ts-ignore
    delete this.$options.sockets.onmessage
}

clearCopyData() {
    this.cut.copy_objects = false;
    this.cut.copy_grouped_objects = false;
    this.cut.copy_contractor = false;
    this.cut.copy_tariffs_structure = false;
    this.cut.copy_tariffs_value = false;
    this.cut.copy_ok_xn_loss_value = false;
    this.cut.copy_shop_structure = false;
    this.cut.copy_shop_value = false;
    this.cut.copy_realization_structure = false;
    this.cut.copy_realization_value = false;
    this.cut.copy_transport_expenses_structure = false;
    this.cut.copy_transport_expenses_value = false;
    this.cut.copy_transport_revenue_structure = false;
    this.cut.copy_transport_revenue_value = false;
    this.cut.copy_fb_tec_loses = false;
    this.cut.copy_fb_use_leave = false;
    this.cut.copy_fb_com_loses = false;
}

get cutSource() {
    if (this.cut.copy_type === this.localTypeCut[0].name) return this.cutsBusiness;
    if (this.cut.copy_type === this.localTypeCut[1].name) return this.cutsFacts;
    return this.cutsUsers
}

@Watch("cut.copy_id_year")
async changeCutList() {
    if(this.cut.copy_id_year) {
      this.allTypeCuts = [];
      this.cutsBusiness = [];
      this.cutsFacts = [];
      this.cutsUsers = [];
        const response = await CutService.getWithFilter(this.cut.copy_id_year);
        if (response?.data) {
            this.allTypeCuts = _.cloneDeep(response.data)
            this.cutsBusiness = this.allTypeCuts.filter((c:CutType) => c.type === this.localTypeCut[0].name && this.cut.id !== c.id);
            this.cutsFacts = this.allTypeCuts.filter((c:CutType) => c.type === this.localTypeCut[1].name && this.cut.id !== c.id);
            this.cutsUsers = this.allTypeCuts.filter((c:CutType) => c.type === this.localTypeCut[2].name && this.cut.id !== c.id);
            this.cut.copy_name = null;
        }
    }
}

@Watch("cut.copy_data")
shiftClear() {
    if (this.cut.copy_data === true) {
        this.cut.clear_cut = false;
        this.cut.copy_tariffs_value = false;
        this.cut.copy_shop_value = false;
        this.cut.copy_realization_value = false;
        this.cut.copy_transport_expenses_value = false;
        this.cut.copy_transport_revenue_value = false;
        this.cut.copy_fb_use_leave = false;
        this.cut.copy_ok_xn_loss_value = false;
    }
    if (this.cut.copy_data === false && this.cut.clear_cut === false) {
        this.cut.copy_id_year= null;
        this.cut.copy_name = null;
        this.cut.copy_type = null;
        this.cut.copy_all_filials = false;
        this.cut.copy_filial = false;
        this.cut.copy_filial_name = null;
        this.cut.copy_facility = false;
        this.cut.copy_facility_name = null;
        this.clearCopyData();
    }
}

@Watch("cut.clear_cut")
shiftCopy() {
    if (this.cut.clear_cut === true) {
        this.cut.copy_data = false;
        this.cut.copy_id_year = null;
        this.cut.copy_type = null;
        this.cut.copy_name = null;
        this.cut.copy_all_filials = false;
        this.cut.copy_filial = false;
        this.cut.copy_filial_name = [];
        this.cut.copy_facility = false;
        this.cut.copy_facility_name = [];
        this.cut.copy_objects = false;
        this.cut.copy_grouped_objects = false;
        this.cut.copy_contractor = false;
        this.cut.copy_tariffs_structure = false;
        this.cut.copy_shop_structure = false;
        this.cut.copy_realization_structure = false;
        this.cut.copy_transport_expenses_structure = false;
        this.cut.copy_transport_revenue_structure = false;
        this.cut.copy_fb_tec_loses = false;
        this.cut.copy_fb_com_loses = false;
    }
    if (this.cut.copy_data === false && this.cut.clear_cut === false) {
        this.cut.copy_id_year= null;
        this.cut.copy_name = null;
        this.cut.copy_type = null;
        this.cut.copy_all_filials = false;
        this.cut.copy_filial = false;
        this.cut.copy_filial_name = null;
        this.cut.copy_facility = false;
        this.cut.copy_facility_name = null;
        this.clearCopyData();
    }
}

@Watch("cut.copy_type")
changeCopyType() {
    this.cut.copy_name = null;
    this.cut.copy_all_filials = false;
    this.cut.copy_filial = false;
}

@Watch("cut.copy_name")
async changeCopyName() {
  this.allFilial = [];
  this.cut.copy_filial_name = [];

  if (!this.cut.copy_name) {
    return
  }

  const copy_cut = this.allTypeCuts.find((x: CutType) => {
    return x.id === this.cut.copy_name
  });
  if (!copy_cut) {
    return
  }
  this.cut.copy_id_eco_version = copy_cut.id_eco_version;
  await this.loadFilialList(copy_cut.id_eco_version);

}

  async loadFilialList(copy_eco_version: number | null) {
    const year = this.all_years.find((y:YearType) => y.id === this.cut.copy_id_year);
    if(copy_eco_version && year?.name) {

      const months: any = [];
      const response = await EcoObjectsService.get_filials(copy_eco_version, year.name, months);
      if (response.data) {
        this.allFilial = response.data
      }
    }
  }

  async analizeAllowed() {
    // анализ допустимых для копирования категорий данных

    if (!(this.cut.copy_all_filials || (this.cut.copy_filial_name && this.cut.copy_filial_name.length > 0))) {
      return
    }

    if (!(this.cut.copy_name && this.cut.id && this.cut.id_eco_version && this.cut.copy_id_year && this.cut.copy_name && this.cut.copy_id_eco_version)) {
      return
    }

    this.analyze_cut = true;
    this.resetCategoriesCheckbox();

    try {
      const response = await CutService.getCopyPermissions(this.cut.id, this.cut.copy_name,
        this.cut.copy_all_filials, this.cut.copy_filial_name, this.cut.copy_facility_name,
        this.cut.id_eco_version, this.cut.copy_id_eco_version, this.cut.id_year, this.cut.copy_id_year);

      if (response?.data) {
        this.copyPermissions = {...this.copyPermissions, ...response.data};
      }
    } catch (e) {
      //
    }

    this.analyze_cut = false;
  }

@Watch("cut.copy_all_filials")
async clearData() {
    if (this.cut.copy_all_filials === false) {
        this.cut.copy_filial_name = null;
        this.cut.copy_facility_name = null;
        this.cut.copy_facility = false;
        this.cut.copy_filial = false;
        this.clearCopyData();
        this.copyPermissions = {
            tariffs: false,
            contractor: false,
            purchases: false,
            sales: false,
            transport_expenses: false,
            transport_revenue: false,
            okhn: false,
            fb2_use_leave: false,
            fb2_tec_loses: false,
            fb2_com_loses: false
        };
    }

    this.analizeAllowed();

}

@Watch("cut.copy_filial")
banFilial() {
    if (this.cut.copy_filial === false) {
        this.cut.copy_filial_name = null;
        this.cut.copy_facility_name = [];
        this.cut.copy_facility = false;
        this.clearCopyData();
        this.copyPermissions = {
            tariffs: false,
            contractor: false,
            purchases: false,
            sales: false,
            transport_expenses: false,
            transport_revenue: false,
            okhn: false,
            objects: false,
            fb2_use_leave: false,
            fb2_tec_loses: false,
            fb2_com_loses: false
        };
    } else {
        this.cut.copy_all_filials = false;
    }
}

@Watch("cut.copy_filial_name")
async clearFilial() {
    if (this.cut.copy_filial_name?.length === 0) {
        this.cut.copy_facility_name = [];
        this.cut.copy_facility = false;
        this.clearCopyData();
        this.copyPermissions = {
            tariffs: false,
            contractor: false,
            purchases: false,
            sales: false,
            transport_expenses: false,
            transport_revenue: false,
            okhn: false,
            objects: false,
            fb2_use_leave: false,
            fb2_tec_loses: false,
            fb2_com_loses: false
        };
    } else {
        if (!(this.cut.copy_name && this.cut.id && this.cut.id_eco_version && this.cut.copy_id_year && this.cut.copy_name && this.cut.copy_id_eco_version && this.cut.copy_filial_name)) {
            return
        }
        // выбраны филиалы без указания объектов
        this.allFacility = [];
        const year = this.all_years.find((y:YearType) => y.id === this.cut.copy_id_year);
        const months: any = [];
        if (year?.name) {
          let nodes: any[] = [];
          const response = await EcoObjectsService.get_heat_nodes(this.cut.copy_id_eco_version, null, year.name, months, this.cut.copy_filial_name);
          if (response?.data) {
            nodes = [...response.data];
          }

          if (nodes.length > 0) {
            const node_ids = nodes.map((e: any) => {
              return e.id
            });

            const response = await EcoObjectsService.get_facilities(this.cut.copy_id_eco_version, null, node_ids, year.name, months);
            if (response?.data) {
              this.allFacility = [...response.data];
            }
          }
        }
    }
}

async updateFilial() {

    if (this.cut.copy_filial_name?.length === 0 || (this.cut.copy_filial_name?.length && this.cut.copy_filial_name?.length > 1)) {
        this.cut.copy_facility_name = [];
        this.cut.copy_facility = false;
    }

    await this.analizeAllowed();
}

@Watch("cut.copy_facility")
banFacility() {
    if (this.cut.copy_facility === false) {
        this.cut.copy_facility_name = null;
        this.clearCopyData();
        this.copyPermissions = {
            tariffs: false,
            contractor: false,
            purchases: false,
            sales: false,
            transport_expenses: false,
            transport_revenue: false,
            okhn: false,
            objects: false,
            fb2_use_leave: false,
            fb2_tec_loses: false,
            fb2_com_loses: false
        };
    }
}

@Watch("cut.copy_facility_name")
clearnFacilityName() {
    if (this.cut.copy_facility_name?.length === 0) {
        this.clearCopyData();
        this.copyPermissions = {
            tariffs: false,
            contractor: false,
            purchases: false,
            sales: false,
            transport_expenses: false,
            transport_revenue: false,
            okhn: false,
            objects: false,
            fb2_use_leave: false,
            fb2_tec_loses: false,
            fb2_com_loses: false
        };
    }
}

async updateFacility() {
  await this.analizeAllowed();
}

resetCategoriesCheckbox() {
  this.cut.copy_tariffs_value =
    this.cut.copy_shop_value =
      this.cut.copy_realization_value =
        this.cut.copy_transport_expenses_value =
          this.cut.copy_transport_revenue_value =
            this.cut.copy_ok_xn_loss_value =
              this.cut.copy_fb_tec_loses =
                this.cut.copy_fb_use_leave =
                  this.cut.copy_fb_com_loses = false;
}


@Watch("cut.acceptance")
clearMonths() {
    if (this.cut.acceptance === false) {
        this.cut.january = this.cut.february = this.cut.march = this.cut.april = this.cut.may = this.cut.june =
        this.cut.july = this.cut.august = this.cut.september = this.cut.october = this.cut.november = this.cut.december = false;
        if (this.localPopupOptions.editMode) {
            for (let m of this.monthsDS) {
                this.cut[m.code] = this.target_cut[m.code];
            }
        }
    }
}

@Watch("cut.copy_tariffs_structure")
clearCutTariffValue() {
    if (!this.cut.copy_tariffs_structure && this.cut.copy_tariffs_value) {
        this.cut.copy_tariffs_value = false;
    }
}

@Watch("cut.copy_shop_structure")
clearCutShopValue() {
    if (!this.cut.copy_shop_structure && this.cut.copy_shop_value) {
        this.cut.copy_shop_value = false;
    }
}

@Watch("cut.copy_realization_structure")
clearCutRealizationValue() {
    if (!this.cut.copy_realization_structure && this.cut.copy_realization_value) {
        this.cut.copy_realization_value = false;
    }
}

@Watch("cut.copy_transport_expenses_structure")
clearCutTransportExpensesValue() {
    if (!this.cut.copy_transport_expenses_structure && this.cut.copy_transport_expenses_value) {
        this.cut.copy_transport_expenses_value = false;
    }
}

@Watch("cut.copy_transport_revenue_structure")
clearCutTransportRevenueValue() {
    if (!this.cut.copy_transport_revenue_structure && this.cut.copy_transport_revenue_value) {
        this.cut.copy_transport_revenue_value = false;
    }
}

async resetManualCorrectionsAndRecalc() {
    // Здесь должен быть вызов сервиса/метода, который обнуляет корректировки стоимости и пересчитывает стоимость по тарифу для всех объектов и филиалов
    // Примерно:
    // await CutService.resetManualCorrectionsAndRecalc(this.cut.id);
    // Для MVP можно просто добавить флаг или комментарий
    // TODO: реализовать реальный сброс и пересчёт на бэке
}

}
